import { axiosV2 } from 'interceptors/axios';
import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

export type PartnerIdentifier = {
  _id: string;
  cif?: string;
};

export const getPartnerIdentifiers =
  (societyId: string) => async (dispatch: any) => {
    try {
      const { data } = await axiosV2.get('/partners/identifiers', {
        params: { societyId },
      });

      const decodedData = (await decryptResponse(data)) as PartnerIdentifier[];

      return decodedData;
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };
